import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import { ToastProvider } from "./components/ToastProvider";
import "./styles.css";
import "./pages/ui-density.css";
import "./theme-cobalt.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 800, retry: 1, refetchOnWindowFocus: true },
    mutations: { retry: false },
  },
});

// Data-router navigation covers links, programmatic buttons and browser history.
const router = createBrowserRouter([{ path: "*", element: <App /> }]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider><RouterProvider router={router} /></ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
